// eslint-disable-next-line import/no-unresolved
import { PaymentAction } from '@adyen/adyen-web/dist/types/types';
import { useCallback, useEffect, useRef, useState } from 'react';

import { useConfig } from '../../../config/ConfigProvider';
import { Environment, Locale, PaymentMethod, ShopBundle } from '../../../types';

import ActionCreator from './ActionCreator';
import { handleQrCodeFailureRedirect, FAILED_QR_CODE_REDIRECT_URL } from './utils/redirect';

export type PaymentAuthorizationActionProps = {
  shopBundle: ShopBundle;
  locale: Locale;
  paymentMethod: PaymentMethod;
  csrfToken: string;
  paymentId: string;
  paymentAction: PaymentAction;
  env: Environment;
};

const CHECKOUT_PROCESS_PAYMENT_URL = '/checkout/paymentrouter/processPaymentDetails';

const ShopCheckoutActionCreator: React.FC<PaymentAuthorizationActionProps> = ({
  shopBundle,
  locale,
  csrfToken,
  paymentAction,
  paymentId,
  paymentMethod,
}) => {
  const {
    config: {
      adyen: { clientKey },
      env,
    },
  } = useConfig();
  const formRef = useRef<HTMLFormElement>(null);
  const [detailsPayload, setDetailsPayload] = useState<string>();

  const handlePaymentDetails = useCallback((payload: string) => {
    setDetailsPayload(payload);
  }, []);

  const actionTimedOutHandler = useCallback(() => {
    handleQrCodeFailureRedirect();
  }, []);

  useEffect(() => {
    if (!!detailsPayload && formRef && formRef.current) {
      formRef.current.submit();
    }
  }, [detailsPayload]);

  return (
    <>
      <ActionCreator
        paymentAction={paymentAction}
        clientKey={clientKey}
        adyenEnvironment={env === 'prod' ? 'live' : 'test'}
        locale={locale}
        sendPaymentDetailsHandler={handlePaymentDetails}
        actionTimedOutHandler={actionTimedOutHandler}
        shopBundle={shopBundle}
        invalidQRCodeActionShopUrl={FAILED_QR_CODE_REDIRECT_URL}
      />
      <form ref={formRef} action={CHECKOUT_PROCESS_PAYMENT_URL} method="post" noValidate>
        <input type="hidden" name="csrfToken" value={csrfToken} />
        <input type="hidden" name="payload" value={detailsPayload} />
        <input type="hidden" name="paymentId" value={paymentId} />
        <input type="hidden" name="paymentMethod" value={paymentMethod} />
      </form>
    </>
  );
};

export default ShopCheckoutActionCreator;
